import { render, staticRenderFns } from "./tablePost.vue?vue&type=template&id=63db1bb0&"
import script from "./tablePost.vue?vue&type=script&lang=js&"
export * from "./tablePost.vue?vue&type=script&lang=js&"
import style0 from "./tablePost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports